import { Checkbox, FormControlLabel } from '@mui/material';
import { NavDropdown } from 'app/shared/layout/menus/menu-components';
import { PeriodicType } from 'app/shared/model/enumerations/periodicType';
import { showElement } from 'app/shared/util/data-utils';
import React from 'react';
import { IUserSetupJourney } from '../../interface/dashboardTruckImplementInterface';
import { getStorageOptions, IdStorageTypes, setStorageOptions } from './storageOptions';

export const UserMapSetupCollapse = (props: IUserSetupJourney) => {
  return (
    <NavDropdown id="drop-sub-options" icon="road" direction="up">
      <div className="container-options">
        {!props.isCompany && (
          <>
            <div title="Visualizar rotas">
              <FormControlLabel
                control={<Checkbox />}
                label="Rotas"
                disabled={props.routes?.length ? false : true}
                checked={props.checkedRoutes}
                onChange={(e, checked) => [setStorageOptions(IdStorageTypes.ROUTES, checked), props.setCheckedRoutes(getStorageOptions(IdStorageTypes.ROUTES))]}
              />
            </div>
            <hr />
          </>
        )}
        <div title="Visualizar informações da rota" style={showElement(props.isBetaVersion)}>
          <FormControlLabel
            control={<Checkbox />}
            label="Informações da rota"
            checked={props.checkedInfoRoute}
            onChange={(e, checked) => [
              setStorageOptions(IdStorageTypes.INFO_ROUTE, checked),
              props.setCheckedInfoRoute(getStorageOptions(IdStorageTypes.INFO_ROUTE)),
            ]}
          />
        </div>
        {(props.periodType === PeriodicType.TODAY || props.isCompany) && (
          <div title="Visualizar tráfego">
            <FormControlLabel
              control={<Checkbox />}
              label="Tráfego"
              checked={props.checkedTraffic}
              onChange={(e, checked) => [
                setStorageOptions(IdStorageTypes.TRAFFIC, checked),
                props.setCheckedTraffic(getStorageOptions(IdStorageTypes.TRAFFIC)),
              ]}
            />
          </div>
        )}
      </div>
    </NavDropdown>
  );
};
